import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative inline-flex w-full" }
const _hoisted_2 = ["disabled", "aria-disabled", "placeholder", "aria-placeholder", "value", "type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      disabled: _ctx.disabled,
      "aria-disabled": _ctx.disabled,
      placeholder: _ctx.placeholder,
      "aria-placeholder": _ctx.placeholder,
      value: _ctx.modelValue,
      type: _ctx.type,
      class: _ctx.classes,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }), null, 16, _hoisted_2)
  ]))
}